import React from "react";
import leftsm from "../assets/icons/leftsm.svg"

const Projects = () => {
  return (
    <div id="projects" className="py-6 md:p-20 border-b cursor-default">
      <h1 className="font-bold text-[#FF6812] text-xl md:text-4xl pb-2 md:pb-6">Projects</h1>
      <p className="text-sm md:text-2xl pb-6 md:pb-12">
        I have <span className="text-[#FF6812]">contributed</span> to projects
        with various roles. These projects have allowed me to{" "}
        <span className="text-[#FF6812]">improve my skills</span>.
      </p>
      <div className="grid md:grid-cols-2 gap-4 md:gap-8">
        <div className="bg-[#202020] rounded-xl p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
          <p className="text-xs md:text-base text-[#FF6812]">UI/UX & BACKEND</p>
          <h1 className="my-6 text-xl md:text-4xl font-extrabold">DAILY COURSE</h1>
          <p className="mb-6">Daily course is an online learning course website that aims to provide quality learning courses.</p>
          <div className="flex justify-between items-center">
            <p className="text-sm md:text-base">ONGOING</p>
            <img src={leftsm} alt="" className="w-6 md:w-8"/>
          </div>
        </div>
        <div className="bg-[#202020] rounded-xl p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
          <p className="text-xs md:text-base text-[#FF6812]">UI/UX & BACKEND</p>
          <h1 className="my-6 text-xl md:text-4xl font-extrabold">BADONORDARAH</h1>
          <p className="mb-6">Badonordarah is a website that helps to find blood for those in need and connects those who can donate blood.</p>
          <div className="flex justify-between items-center">
            <p className="text-sm md:text-base">Developed In 2023</p>
            <img src={leftsm} alt="" className="w-6 md:w-8"/>
          </div>
        </div>
        <div className="bg-[#202020] rounded-xl p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
          <p className="text-xs md:text-base text-[#FF6812]">BACKEND</p>
          <h1 className="my-6 text-xl md:text-4xl font-extrabold">Medical Robot Assistant</h1>
          <p className="mb-6">Medical Robot Assistant is a medical app to monitor patient vitals such as heart rate, body temperature, and oxygen levels.</p>
          <div className="flex justify-between items-center">
            <p className="text-sm md:text-base">Developed In 2022</p>
            <img src={leftsm} alt="" className="w-6 md:w-8"/>
          </div>
        </div>
        <div className="bg-[#202020] rounded-xl p-6 transition ease-in-out delay-150 hover:-translate-y-0 hover:scale-110 duration-300 cursor-pointer">
          <p className="text-xs md:text-base text-[#FF6812]">BACKEND, APIs & MICROSERVICES</p>
          <h1 className="my-6 text-xl md:text-4xl font-extrabold">TEMAN BICARA</h1>
          <p className="mb-6"> Teman-Bicara is a mobile app designed to support mental health by offering users a platform to talk and consult with psychologists.</p>
          <div className="flex justify-between items-center">
            <p className="text-sm md:text-base">Developed In 2022</p>
            <img src={leftsm} alt="" className="w-6 md:w-8"/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Projects;
